import {Subscription} from "rxjs";
import {RouterLink} from "@angular/router";
import {DatePipe, NgClass} from "@angular/common";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {appRoutes} from "@numizmat/constants";
import {ModalService} from "@numizmat/services/common";
import {PublicAdDetailResponse} from "@numizmat/services-models/core";
import {AdStatus, AdType, DealParticipantType} from "@numizmat/enumerations";
import {AdDetailStateService} from "@numizmat/services/core/ad-detail/ad-detail-state.service";
import {
  ConversationMessageModalComponent,
  UserFeedbackModalComponent,
  UserReportModalComponent
} from "@numizmat/modals";

@Component({
    selector: 'nz-ad-status-info',
    imports: [
        DatePipe,
        NgClass,
        RouterLink
    ],
    templateUrl: './ad-status-info.component.html',
    styleUrl: './ad-status-info.component.scss'
})
export class AdStatusInfoComponent implements OnInit, OnDestroy {
  private modalService: ModalService = inject(ModalService);
  private adDetailStateService: AdDetailStateService = inject(AdDetailStateService);

  private subs: Subscription = new Subscription();

  protected adDetails!: PublicAdDetailResponse;
  protected readonly AdType = AdType;
  protected readonly AdStatus = AdStatus;
  protected readonly appRoutes = appRoutes;
  protected readonly DealParticipantType = DealParticipantType;

  public ngOnInit(): void {
    this.getAdDetails();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onOpenConversationMessageModal(dealParticipantType: DealParticipantType) {
    const modalRef: NgbModalRef = this.modalService.open(ConversationMessageModalComponent, {
      scrollable: true
    });
    modalRef.componentInstance.adId = this.adDetails.adId;
    modalRef.componentInstance.adTitle = this.adDetails.title;
    modalRef.componentInstance.adPrice = this.adDetails.price;
    modalRef.componentInstance.dealParticipantType = dealParticipantType;
    modalRef.componentInstance.interlocutorUsername = dealParticipantType === DealParticipantType.Seller
      ? this.adDetails.buyerUsername
      : this.adDetails.sellerUsername;
  }

  protected onOpenUserFeedbackModal(dealParticipantType: DealParticipantType) {
    const modalRef: NgbModalRef = this.modalService.open(UserFeedbackModalComponent, {
      scrollable: true
    });
    modalRef.componentInstance.adId = this.adDetails.adId;
    modalRef.componentInstance.dealParticipantType = dealParticipantType;
  }

  protected insertUserReport(userId: string, username: string): void {
    const modalRef: NgbModalRef = this.modalService.open(UserReportModalComponent);
    modalRef.componentInstance.userId = userId;
    modalRef.componentInstance.username = username;
  }

  private getAdDetails(): void {
    const subscription: Subscription = this.adDetailStateService.getPublicAdDetails().subscribe({
      next: (adDetails: PublicAdDetailResponse | undefined) => {
        if (!!adDetails) {
          this.adDetails = adDetails;
        }
      }
    });
    this.subs.add(subscription);
  }
}
